import { render, staticRenderFns } from "./app-event-contact-info.vue?vue&type=template&id=0a901144&"
import script from "./app-event-contact-info.vue?vue&type=script&lang=js&"
export * from "./app-event-contact-info.vue?vue&type=script&lang=js&"
import style0 from "./app-event-contact-info.vue?vue&type=style&index=0&id=0a901144&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports